// eslint-disable-next-line
import React, { ComponentType } from 'react';
import { Typography, TypographyProps } from '@material-ui/core';
import styled from 'styled-components';

export type TextColor =
  | 'initial'
  | 'inherit'
  | 'primary'
  | 'secondary'
  | 'textPrimary'
  | 'textSecondary'
  | 'error';

type MyTypoProps = Omit<TypographyProps, 'variant' | 'variantMapping'> & {
  component?: React.ElementType;
};

const Title = styled(({ component = 'h1', ...props }) => (
  <Typography {...props} variant="h5" component={component} />
))`` as ComponentType<MyTypoProps>;

const TitleTwo = styled(({ component = 'h2', ...props }) => (
  <Typography {...props} variant="h6" component={component} />
))`` as ComponentType<MyTypoProps>;

const Subtitle = styled(({ component = 'h3', ...props }) => (
  <Typography {...props} variant="subtitle1" component={component} />
))`` as ComponentType<MyTypoProps>;

const Text = styled((props) => (
  <Typography {...props} variant="body1" />
))`` as ComponentType<MyTypoProps>;

const TextTwo = styled((props) => (
  <Typography {...props} variant="body2" />
))`` as ComponentType<MyTypoProps>;

export { Title, TitleTwo, Subtitle, Text, TextTwo };
